import { Button } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

import profile from "../../../assets/image/Taifur.jpg";
import "./user.scss";

const Users = () => {
  const naviagte = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("loginInfo");
    naviagte("/");
  };
  return (
    <div className="user-container">
      <table>
        <thead>
          <tr>
            <th>IMAGE</th>
            <th>NAME</th>
            <th>EMAIL</th>
            <th>ACTION</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <img src={profile} alt="Taifur" />
            </td>
            <td>Taifur Islam</td>
            <td>Taifurislamashraf@gamil.com</td>
            <td>
              <Button className="action-btn" onClick={handleLogout}>
                Logout
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Users;
